import * as React from 'react';
import './ExpandableDesktop.scss';
import ReactToPrint from 'react-to-print';
import localeFormatingInstance from 'src/translation/localeFormating';
import Button from 'src/components/common/Button';
import { IReturnDetail, IStatusItem } from 'src/services/returns/typings';
import {
  RMA_EDIT,
  RMA_SUBMIT,
  IRmaModalData
} from 'src/pages/ReturnsView/ReturnsView';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import ExpandableRowDesktop from '../ExpandableRowDesktop';
import ContentToPrint from '../../../ContentToPrint';
import { ERmaStatus } from '../../StatusTab';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import i18n from 'src/translation/i18n';
import ShippingLabelToPrint from '../../../ShippingLabelToPrint';
import CaShippingLabelWIndow from '../CaShippingLabelWIndow';
import env from 'src/shared/env';

interface IExpandableDesktopProps {
  statusData: IStatusItem;
  handleShowRmaModal: (state: boolean, rmaModalData: IRmaModalData) => void;
  setSelectedReturnToDelete: (id: string) => void;
  isDownloadingPdf: boolean;
  downloadPdf: (rmaNumber: string, isPrepaidLabel: string) => void;
  clearEligibleFilters: () => void;
  t?: any;
}

const calculateResult = (returnDetails: IReturnDetail[]): number => {
  let result = 0;

  returnDetails.forEach(r => {
    result += r.returnAmount;
  });

  return result;
};

const ExpandableDesktop: React.FC<IExpandableDesktopProps> = props => {
  const componentRef = React.useRef();
  const componentShippingRef = React.useRef();
  const [isDownloadingDetails, setIsDownloadingDetails] = React.useState<boolean>(false);
  const [isShippingDownloadingDetails, setIsShippingDownloadingDetails] = React.useState<boolean>(false);
  const [documentTitle, setDocumentTitle] = React.useState<string>('');
  const [hideShowPdfError, setHideShowPdfError] = React.useState(false);
  const [cAPrintLabelReady, setCaPrintLabelReady] = React.useState<boolean>(false);
  const [isLoadingBarcode, setisLoadingBarcode] = React.useState<boolean>(false);
  const {
    statusData,
    handleShowRmaModal,
    setSelectedReturnToDelete,
    isDownloadingPdf,
    downloadPdf,
    clearEligibleFilters,
    t
  } = props;

  const handleOpenModal = (action: string) => {
    handleShowRmaModal(true, {
      action,
      data: statusData.returnDetails,
      rmaNumber: statusData.rmaNumber,
      poNumber: statusData.poNumber
    });
  };

  const getRmaStatusType = (rStatus: string, rButtonName: string, shippingType: string) => {
      switch (rStatus) {
          case 'IN PROGRESS':
            return 'NO';
            break;
          case 'NOT SUBMITTED':
            return 'YES';
            break;
          case 'CANCELLED':
            return 'NO';
            break;
          case 'PARTIALLY_CANCELLED':
            return 'NO'
            break;
          case 'COMPLETED':
            return 'NO'
            break;  
          default:
            return 'NO'
      }
  };
  const getInvoicePreview = (invoiceNumber: number, invoiceDate: string) => {
    // window.scrollTo({ top: 0, behavior: 'smooth' });
    InvoiceService.downloadInvoice(
      String(invoiceNumber),
      String(statusData.creditedDate)
    )
      .then((response: any) => {
        downloadFile(
          response.data,
          `invoice-${invoiceNumber}-${localeFormatingInstance.getNowDate(
            'short'
          )}.pdf`
        );
      })
      .catch(error => {
        console.log(error);
        setHideShowPdfError(true);
        // window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  };
  const getCaPrintingLabel = () => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(true);
  };

  const rePrintBarcode = (rmaBarcodeNo: string, shipmentType: string) => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(false);
    if(shipmentType==="PREPAID_SHIPPING"){
      downloadPdf(rmaBarcodeNo,'yes');
    }else{
      downloadPdf(rmaBarcodeNo,'no'); 
    }
  };
  const closeWindowPortal = () => {
    setCaPrintLabelReady(false);
   };

   const getShippingTypeStatus = (rawTxt: string) => {
    switch (rawTxt?.toLowerCase()) {
      case 'drop_off_store':
        return t('myReturns.dropOffStoreText');
      case 'self_shipping':
        return t('myReturns.selfShippingText');
      case 'prepaid_shipping':
        return t('myReturns.prepaidShippingText');
      default:
        return rawTxt;
    }
  };
  return (
    <div className="rp-expandable-desktop">
      <div style={{ display: 'none' }}>
        <ContentToPrint
          ref={componentRef}
          total={calculateResult(statusData.returnDetails)}
          statusData={statusData}
        />
      </div>
      <div style={{ display: 'none' }}>
        <ShippingLabelToPrint
          ref={componentShippingRef}
          shippingLabel={statusData.shippingLabelUrls}
        />
      </div>
      {cAPrintLabelReady &&
        <CaShippingLabelWIndow 
        closeWindowPortal={closeWindowPortal}
        >
            {statusData.shippingLabelUrls.map((img: any, index: number) =>
                <div className="rp-content-to-print-row" key={index}> 
                <div className="container-fluid">
                      <p className="rp-content-to-print-row-content quantity text-center">
                      <object data={img} type="application/pdf" style={{width: "100%",height: "100%"}} >
                      <embed src={img} type="application/pdf" style={{width: "100%",height: "100%"}} />
                      </object> 
                      </p>
                </div>
              </div>
              )}
        </CaShippingLabelWIndow>
        }
      {hideShowPdfError ? (
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setHideShowPdfError(false);
              }}
            >
              <MatrialCloseIcon fontSize="inherit" />
            </IconButton>
          }
          severity="error"
        >
          <div>
            <div className="error-message-to-show">
              {i18n.t('invoices.downloaderror')}
            </div>
          </div>
        </Alert>
      ) : (
        ''
      )}

      <div className="container-fluid">
        <div className="row rp-expandable-desktop-wrapper">
          <div className="col-2 partNumber">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.partNo')}{' '}
            </p>
          </div>
          <div className="col-1 invoiceNumber">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.invoiceNo')}
            </p>
          </div>
          <div className="col-1 invoiceDate">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.invoiceDate')}
            </p>
          </div>
          <div className="col-1 price">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.price')}
            </p>
          </div>
          <div className="col-1 d-flex justify-content-center returnQty">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.returnQty')}
            </p>
          </div>
          <div className="col-1 d-flex justify-content-center restockingFee">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.restockingFee')}
            </p>
          </div>
          <div className="col-2 d-flex justify-content-center creditAmount">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.creditAmount')}
            </p>
          </div>
          <div className="col-2 reason">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.reasonReference')}
            </p>
          </div>
          <div className="col-2 creditInvoice">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.creditInvoice')}
            </p>
          </div>
          <div className="col-2 status">
            <p className="rp-expandable-desktop-header">
              {t('myReturns.statusHeader')}
            </p>
          </div>
        </div>
      </div>

      {statusData.returnDetails.map(returnDetail => (
        <ExpandableRowDesktop
          key={returnDetail.id}
          returnDetail={returnDetail}
          getInvoicePreview={getInvoicePreview}
        />
      ))}

      <div className="container-fluid">
      {statusData.shipmentType!==null  &&
      <React.Fragment>
        <div className="row d-flex justify-content-end rp-expandable-desktop-total">
          <div className="col-6 d-flex">
            <p className="rp-expandable-desktop-total-text">
             {t('myReturns.shippingType')}
            </p>
              {/* Shipping Type */}
              <p className='greenText'>
              {getShippingTypeStatus(statusData.shipmentType)}
              </p>

          </div>
        </div>
        </React.Fragment>
        }

        {statusData.shippingCharges >0 &&
        <div className="row d-flex justify-content-end rp-expandable-desktop-total">
          <div className="col-6 d-flex">
            <p className="rp-expandable-desktop-total-text">
             {t('myReturns.shippingCharges')}
            </p>
              {/* Shipping Label Charges */}
              <p className='greenText'>
              {localeFormatingInstance.formatCurrency(statusData.shippingCharges)}
              </p>

          </div>
        </div>
        }

      {statusData?.trackingNumbers!==null && statusData?.trackingNumbers.length >0 &&
        <div className="row d-flex justify-content-end rp-expandable-desktop-total">
          <div className="col-6 d-flex">
            <p className="rp-expandable-desktop-total-text">
             {t('myReturns.trackingNumber')}
            </p>
              {/* Tracking Numbers */}
              <p className='greenText'>
              {statusData.trackingNumbers.map((trackingNumbers, index) => (
                <span key={index}>{trackingNumbers} &nbsp;</span>
              ))}
              </p>

          </div>
        </div>
        }

        

        <div className="row d-flex justify-content-end rp-expandable-desktop-total">
          <div className="col-6 d-flex">
            <p className="rp-expandable-desktop-total-text">
              {`${t('common.totalCapsTxt')} ${
                statusData.status !== ERmaStatus.COMPLETED
                  ? `${t('common.estimated')}`
                  : ''
              } ${t('common.credit')}`}
            </p>
            {/*<p>
              {localeFormatingInstance.formatCurrency(
                calculateResult(statusData.returnDetails)
              )}
              </p>
              */}
              {/* total excluding shipping label else normal total */}
              <p className='greenText'>
              {localeFormatingInstance.formatCurrency(statusData.returnTotal)}
              </p>

          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row rp-expandable-desktop-options d-flex align-items-center">
          <div className="col-12 d-flex justify-content-end">
           {getRmaStatusType(statusData.status,"DELETE",statusData.shipmentType)==="YES" && 
           (
                <div className="rp-expandable-desktop-remove">
                  <i className="rpds-trash" />
                  <p
                    onClick={() => {
                      setSelectedReturnToDelete(statusData.rmaNumber);
                      clearEligibleFilters();
                    }}
                  >
                   {t('myReturns.deleteReturn')}
                  </p>
                </div>
             )}
            {statusData.status === ERmaStatus.IN_PROGRESS && (
              <div
              onClick={() => rePrintBarcode(statusData.rmaNumber, statusData.shipmentType)}
                className={`rp-expandable-desktop-barcode ${isDownloadingPdf &&
                  'disabled'}`}
              >
                {isDownloadingPdf && (
                  <div className="rp-expandable-desktop-loading">
                    <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                      <div className="ldio-9coovtt1mti">
                        <div />
                      </div>
                    </div>
                  </div>
                )}
                <i className="rpds-barcode" />
                <p>{t('myReturns.rePrintBarcode')}</p>
              </div>
            )}
            {isDownloadingDetails && (
              <div className="rp-expandable-desktop-loading">
                <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                  <div className="ldio-9coovtt1mti">
                    <div />
                  </div>
                </div>
              </div>
            )}
            <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `${
                  statusData.rmaNumber
                }-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsDownloadingDetails(true);
                setCaPrintLabelReady(false);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsDownloadingDetails(false);
                setCaPrintLabelReady(false);
              }}
              trigger={() => (
                <div
                  className={`rp-expandable-desktop-print ${isDownloadingDetails &&
                    'disabled'}`}
                >
                  <i className="rpds-print" />
                  <p>{t('myReturns.printDetails')}</p>
                </div>
              )}
              content={() => componentRef.current}
            />

            {isShippingDownloadingDetails && (
              <div className="rp-expandable-desktop-loading">
                <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                  <div className="ldio-9coovtt1mti">
                    <div />
                  </div>
                </div>
              </div>
            )} 
           {/* Shipping Label Print */}   
           {statusData.shippingLabelUrls && env.REACT_APP_BASE_ENVIRONMENT === 'US' && 
            <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `${
                  statusData.rmaNumber
                }-${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsShippingDownloadingDetails(true);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsShippingDownloadingDetails(false);
              }}
              trigger={() => (
                <div
                  className={`rp-expandable-desktop-print ${isShippingDownloadingDetails &&
                    'disabled'}`}
                >
                  <i className="rpds-print" />
                  <p>{t('myReturns.printShippingLabel')}</p>
                </div>
              )}
              content={() => componentShippingRef.current}
              documentTitle={`${
                statusData.rmaNumber
              }-${'Shipping-Label'
              }-${localeFormatingInstance.getNowDate('short')}.pdf`}
            />
            }   


          {statusData.shippingLabelUrls && env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
          <div className="rp-expandable-desktop-print">
            <i className="rpds-print" />
              <button
                className="print-button"
                onClick={() => getCaPrintingLabel()}
                >
                  <p>{i18n.t('myReturns.printShippingLabel')}</p>
                  </button>
             
          </div>
          }
       

            
               {getRmaStatusType(statusData.status,"EDIT",statusData.shipmentType)==="YES" && (
                <>
                  <div
                    onClick={() => handleOpenModal(RMA_EDIT)}
                    className="rp-expandable-desktop-edit"
                  >
                    <i className="rpds-edit" />
                    <p>{t('myReturns.editReturn')}</p>
                  </div>
                </>
              )}

              {getRmaStatusType(statusData.status,"RESUBMIT",statusData.shipmentType)==="YES" && (
                <>
                  <Button
                    action={() => {
                      handleOpenModal(RMA_SUBMIT);
                      clearEligibleFilters();
                    }}
                    label={t('myReturns.submitReturn')}
                    textTransform="uppercase"
                    buttonClass="rp-expandable-desktop-submit"
                  />
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandableDesktop;
